export default __webpack_public_path__ + "static/media/csrbf_blender.2482b1ad.webp";